import { combineEpics } from 'redux-observable';
/**
 * Epics registered here are studio specific
 * AND not included in exp-ui
 */
import { rootEpic as ExperimentationGroupEpics } from '@ane/exp-ux/lib/components/SelectExperimentationGroup/LoadExperimentationGroups.epics';
import isolationGroupEpics from '@ane/isolation-group-app-module/lib/module/epics';
import analysisConfigModuleEpic from '@ane/analysis-config-app-module/lib/module/epics';
const epics = [ExperimentationGroupEpics, isolationGroupEpics, analysisConfigModuleEpic];
export const rootEpic = combineEpics(...epics);
export default rootEpic;

//# sourceMappingURL=epics.js.map
